import React, { useEffect } from "react";

function AdSenseBanner() {
  useEffect(() => {
    try {
      //(window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      console.error(e);
    }
  }, []);

  return <div></div>;
}

export default AdSenseBanner;
